module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/logo-new.png","name":"Bravo Roofing","short_name":"Bravo Roofing","start_url":"/","background_color":"#ffffff","theme_color":"#ffffff","display":"standalone","description":"Roof replacement, repairs, inspections and storm damage assessments in Boise and the Treasure Valley, Idaho.","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"5ced28ef6073de3d41beea461c738a52"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
